/**
 * @file page banner
 * @author wanzhongyun
 */

import Video from './../../../../components/video-modal/Video';
import { IInterBanner } from './../../types';
import './style.less';

const Banner: React.FC<IInterBanner> = props => {
    const { title, desc, btnWord, btnLink } = props;
    return (
        <div className='paddle-index-page-banner'>
            <Video
                className='paddle-index-page-banner-video'
                controls={false}
                autoPlay
                loop
                muted
                preload='auto'
                poster='https://paddle-site-web-video.cdn.bcebos.com/paddle-inter-video/bannerBack.png'
                src='https://paddle-site-web-video.cdn.bcebos.com/paddle-inter-video/%E5%A4%B4%E5%9B%BE%E8%83%8C%E6%99%AF-%E6%B5%81%E7%95%85%E7%89%88.mov'
            >
            </Video>
            <div className='paddle-index-page-banner-content'>
                <div className='paddle-index-page-banner-content-title'>{ title }<span className='title-point' /></div>
                <div className='paddle-index-page-banner-content-desc'>{ desc }</div>
                {
                    btnWord && <a className='paddle-index-page-banner-content-btn' href={btnLink}>{ btnWord }</a>
                }
            </div>
        </div>
        );
}

export default Banner;